const resultDialog = {
  importResult: "Import the results",
  failReason: "The reason for failure",
  noFailReason: "No import failure information",
  importSuccess: "Import success ",
  unit: " strip",
  importFail: "import failed "
} 
export default resultDialog